export class ApiError extends Error {
    constructor(error) {
        super();
        this.name = 'ApiError';
        this.message = error.message.toString().toLowerCase();
        this.code = error.code ?? 'unknown';
        this.details = error.details;
        Object.setPrototypeOf(this, ApiError.prototype);
    }
}
export class SubmissionError extends Error {
    constructor(errors) {
        super();
        this.name = 'SubmissionError';
        this.message = `failed: ${Object.keys(errors)}`;
        this.errors = errors;
        Object.setPrototypeOf(this, SubmissionError.prototype);
    }
}
export class OAuthError extends Error {
    constructor(code) {
        super(typeof code === 'string' ? code : undefined);
        this.no = code;
        this.code = 'error';
        Object.setPrototypeOf(this, OAuthError.prototype);
    }
}
